<template>
  <span v-if="computedShow" class="billEntryPrefix">{{computedValue}}&#160;</span>
</template>

<script>
export default {
  name: "EntryPrefix",
  props: ["billTemplateEntry"],
  computed: {
    computedShow() {
      if (!this.billTemplateEntry || !this.billTemplateEntry.entrytype) {
        return false;
      }
      return (
        this.billTemplateEntry.entrytype == "less" ||
        this.billTemplateEntry.entrytype == "add"
      );
    },
    computedValue() {
      return this.billTemplateEntry.entrytype == "less" ? "LESS" : "ADD";
    }
  }
  // functional: true,
  // render: function(h, ctx) {
  //   const billEntryPrefix = {
  //     attrs: {
  //       class: "billEntryPrefix"
  //     }
  //   };
  //   return [
  //     ...(ctx.props.entryType == 'less' ? [h('span', billEntryPrefix, 'LESS ')] : []),
  //     ...(ctx.props.entryType == 'add' ? [h('span', billEntryPrefix, 'ADD ')] : [])
  //   ];
  // }
};
</script>

<style>
</style>
